import { createStore } from "vuex";
import persistedStateVuex from "persisted-state-vuex";

export default createStore({
  state: {
    ifAuthorized: false,
  },
  getters: {},
  mutations: {
    getUserLogDetails(state, data) {
      state.userDetails = {
        id: data.id,
        name: data.name,
        role: data.role,
        photoLink: data.photoLink
      };
    },
    authorizedHandler(state, val) {
      state.ifAuthorized = val;
    },
  },
  actions: {},
  modules: {},
  plugins: [persistedStateVuex.init],
});
